import { AirReservationList } from '../components/AirReservationList';

/** "Bilet Listesi" — actually issued/ticketed reservations. Fixed to `status: 'Booked'`;
 *  see components/AirReservationList.tsx for the shared implementation with
 *  "Rezervasyon Listesi" (`status: 'Prebooked'`, pages/AirReservationsPage.tsx). */
export default function AirTicketsPage() {
  return <AirReservationList status="Booked" title="Uçak Bilet Listesi" showTicketColumn />;
}
